(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('.rv-footer:not([data-footer-ready])').forEach((footer) => {
      footer.dataset.footerReady = '';
      const mobile = matchMedia('(max-width: 900px)');
      const buttons = [...footer.querySelectorAll('[data-footer-toggle]')];
      const sync = () => buttons.forEach((button) => {
        const column = button.closest('.rv-footer-column');
        button.disabled = !mobile.matches;
        button.setAttribute('aria-expanded', String(!mobile.matches || column.hasAttribute('data-open')));
      });
      buttons.forEach((button) => button.addEventListener('click', () => {
        if (!mobile.matches) return;
        button.closest('.rv-footer-column').toggleAttribute('data-open');
        sync();
      }));
      mobile.addEventListener('change', sync);
      sync();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', () => initialize(document));
})();
